import React, { type ComponentType } from "react";
import { Route, Switch } from "react-router-dom";
import ResetPasswordView, {
  RESET_PASSWORD_VIEW,
} from "src/authentication/views/ResetPasswordView";

export interface RoutesProps {
  component: ComponentType;
}

export const Routes = ({ component }: RoutesProps) => (
  <>
    <Switch>
      <Route exact path={RESET_PASSWORD_VIEW} component={ResetPasswordView} />
      <Route component={component} />
    </Switch>
  </>
);
